import "./PrivacyPolicy.module.css";
import Header from "@/reusable_sections/Header";
import YourPrivacyMatters from "./sections/YourPrivacyMatters";
import DetailedPrivacyPolicy from "./sections/DetailedPrivacyPolicy";
import Footer from "@/reusable_sections/Footer";
export default function PrivacyPolicyPage() {
  return <div>
      <Header />
      <YourPrivacyMatters />
      <DetailedPrivacyPolicy />
      <Footer />
    </div>;
}